// `Object.entries` does preserve key types.
export const entries = (o) => Object.entries(o);
// `Object.fromEntries` does not preserve key types.
export const fromEntries = (entries) => Object.fromEntries(entries);
